export class ServicesGroupLoader {
    async loadGroup1() {
        return await import(/*webpackChunkName: "services-group1" */'./services.group1');
    }

    async loadGroup2() {
        return await import(/*webpackChunkName: "services-group2" */'./services.group2');
    }

    async loadGroup3() {
        return await import(/*webpackChunkName: "services-group3" */'./services.group3');
    }

    async loadGroup4() {
        return await import(/*webpackChunkName: "services-group4" */'./services.group4');
    }

    async loadGroup5() {
        return await import(/*webpackChunkName: "services-group5" */'./services.group5');
    }
}